import { apiClient } from "../../lib/axios";

export interface ClientBranding {
  client_id: string;
  primary_color?: string | null;
  secondary_color?: string | null;
  accent_color?: string | null;
  background_color?: string | null;
  text_color?: string | null;
  dark_primary_color?: string | null;
  dark_secondary_color?: string | null;
  dark_accent_color?: string | null;
  dark_background_color?: string | null;
  dark_text_color?: string | null;
  chart_primary_color?: string | null;
  chart_secondary_color?: string | null;
  chart_accent_color?: string | null;
  chart_palette?: string[] | null;
  dark_chart_primary_color?: string | null;
  dark_chart_secondary_color?: string | null;
  dark_chart_accent_color?: string | null;
  dark_chart_palette?: string[] | null;
  logo_url?: string | null;
  logo_dark_url?: string | null;
  dark_logo_url?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface ClientBrandingResponse {
  data: ClientBranding | null;
}

export interface UpdateClientBrandingRequest {
  primary_color?: string | null;
  secondary_color?: string | null;
  accent_color?: string | null;
  background_color?: string | null;
  text_color?: string | null;
  dark_primary_color?: string | null;
  dark_secondary_color?: string | null;
  dark_accent_color?: string | null;
  dark_background_color?: string | null;
  dark_text_color?: string | null;
  chart_primary_color?: string | null;
  chart_secondary_color?: string | null;
  chart_accent_color?: string | null;
  chart_palette?: string[] | null;
  dark_chart_primary_color?: string | null;
  dark_chart_secondary_color?: string | null;
  dark_chart_accent_color?: string | null;
  dark_chart_palette?: string[] | null;
  logo_url?: string | null;
  logo_dark_url?: string | null;
  dark_logo_url?: string | null;
}

export const clientBrandingApi = {
  getClientBranding: async (
    clientId: string
  ): Promise<ClientBrandingResponse> => {
    const response = await apiClient.get("/admin/client-branding", {
      params: {
        client_id: clientId,
      },
    });
    return response.data;
  },

  updateClientBranding: async (
    clientId: string,
    data: UpdateClientBrandingRequest
  ): Promise<ClientBrandingResponse> => {
    const response = await apiClient.put("/admin/client-branding", data, {
      params: {
        client_id: clientId,
      },
    });
    return response.data;
  },
};
